import React, { ReactNode } from "react"
import {
  Box,
  FormControl,
  FormHelperText,
  FormLabel,
  Textarea as ChakraTextArea,
  LayoutProps,
} from "@chakra-ui/react"
import { Control, useController } from "react-hook-form"

type Props = {
  name: string
  control: Control<any>
  id?: string
  label?: ReactNode
  ariaLabel?: string
  placeholder?: string
  vertical?: boolean
  helperText?: string
  h?: LayoutProps["height"]
  disabled?: boolean
}

const TextArea = ({
  name, control, id, label, ariaLabel, placeholder, vertical, helperText, h, disabled,
}: Props) => {
  const { field } = useController({ name, control })

  return (
    <FormControl mb={4} display={vertical ? "initial" : "flex"}>
      {label && <FormLabel w={vertical ? "auto" : 1 / 4}>{label}</FormLabel>}
      <Box w="100%">
        <ChakraTextArea
          {...field}
          id={id}
          aria-label={ariaLabel}
          placeholder={placeholder}
          bg="white"
          h={h}
          isDisabled={disabled}
        />
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </Box>
    </FormControl>
  )
}

export default TextArea
